import { referralClient } from "@core/clients";
import { ReferralStats } from "@core/types";
import { useQuery, UseQueryResult } from "@tanstack/react-query";

const useGetReferralStatsQuery = (referralId: string): UseQueryResult<ReferralStats, Error> => {
  return useQuery(["referral-stats", referralId], () => referralClient.getReferralStats(referralId), {
    enabled: !!referralId,
  });
};

export default useGetReferralStatsQuery;
